import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap, mobile } from "@ui/styles/utils";

interface LivesLimitModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const LivesLimitModal: React.FC<LivesLimitModalProps> = ({ close, ...htmlProps }) => {
	return (
		<Container close={close} title={I18n.t("live.threesold")} {...htmlProps}>
			<Actions>
				<SecondaryButton onClick={close}>{I18n.t("close")}</SecondaryButton>
			</Actions>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(25)};
	align-items: center;
	text-align: center;
`;

const Actions = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	flex-direction: column;
	${gap(25)};

	@media ${mobile} {
		${gap(15)};
		> button {
			padding: 12px 20px;
		}
	}
`;
